import React from 'react';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';

class AlertGenericModal extends React.Component {
  constructor() {
    super();
    this.state = {
      showModal: true
    };

    this.handleCloseModal = this.handleCloseModal.bind(this);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({ showModal: nextProps.open });
  }

  handleCloseModal() {
    this.setState({ showModal: false });
  }

  handleConfirmModal(callback) {
    callback();
    this.setState({ showModal: false });
  }

  handleCancelButton(cancelClickButton) {
    const { customCancelButtonResource, isLoading, i18n } = this.props;

    let callback;
    if (cancelClickButton) {
      callback = () => this.handleCancelModal(cancelClickButton);
    } else {
      callback = this.handleCloseModal;
    }

    return (
      <input
        data-testid="alert-cancel-button"
        type="button"
        onClick={callback}
        value={i18n.getResourcesByKey(customCancelButtonResource || 'default.button.cancel')}
        disabled={isLoading}
      />
    );
  }

  handleCancelModal(callback) {
    callback();
    this.setState({ showModal: false });
  }

  showMessageBody() {
    const {
      message,
      i18n,
      formatMessageBodyAsHTML
    } = this.props;

    const translatedMessage = i18n.getResourcesByKey(message);

    return formatMessageBodyAsHTML ? parse(translatedMessage) : translatedMessage;
  }

  getButtonClassName() {
    const { isLoading } = this.props;

    return isLoading ? 'loader-spinner' : '';
  }

  renderCloseButton() {
    const {
      i18n,
      customCancelButtonResource,
      hideCloseButton
    } = this.props;

    if (hideCloseButton)
      return null;

    return (
      <input
        data-testid="alert-close-button"
        type="button"
        className={this.getButtonClassName()}
        onClick={this.handleCloseModal}
        value={i18n.getResourcesByKey(customCancelButtonResource || 'default.button.close')}
      />
    );
  }

  renderAlertConfirmButton() {
    const {
      i18n,
      confirmClickButton,
      customConfirmButtonResource,
      isLoading,
    } = this.props;

    return (
      <input
        data-testid="alert-confirm-button"
        type="button"
        className={this.getButtonClassName()}
        onClick={() => this.handleConfirmModal(confirmClickButton)}
        value={i18n.getResourcesByKey(customConfirmButtonResource || 'default.button.confirm')}
        disabled={isLoading}
      />
    )
  }

  renderActionButtonsGroup() {
    const {
      cancelClickButton,
      isADeleteAction
    } = this.props;

    if(isADeleteAction) {
      return (
        <>
          {this.handleCancelButton(cancelClickButton)}
          {this.renderAlertConfirmButton()}
        </>
      )
    }

    return (
      <>
        {this.renderAlertConfirmButton()}
        {this.handleCancelButton(cancelClickButton)}
      </>
    )
  }

  render() {
    const {
      title,
      i18n,
      confirmClickButton,
      open,
      errorMessage,
      customCssClass,
    } = this.props;

    if (!this.state.showModal || !open) {
      return null;
    }

    return (
      <div data-testid="alert-generic-modal" className={customCssClass ? `alert-generic-modal ${customCssClass}` : 'alert-generic-modal'}>
        <div className="alert-generic-modal__container">
          <div data-testid="alert-title" className="alert-generic-modal__header">
            {title ? i18n.getResourcesByKey(title) : i18n.getResourcesByKey('AlertGenericModal.header.title.default')}
          </div>
          {errorMessage && (
            <div data-testid="alert-error-message" className="alert-generic-modal__error-message">
              {i18n.getResourcesByKey(errorMessage)}
            </div>
          )}
          <div data-testid="alert-message-body" className="alert-generic-modal__content">
            {this.showMessageBody()}
          </div>
          <div className="alert-generic-modal__buttons standard-form-buttons">
            {confirmClickButton ?
              this.renderActionButtonsGroup() :
              this.renderCloseButton()
            }
          </div>
        </div>
      </div>
    );
  }
}

AlertGenericModal.propTypes = {
  title: PropTypes.string,
  i18n: PropTypes.object.isRequired,
  message: PropTypes.string.isRequired,
  confirmClickButton: PropTypes.func,
  open: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool,
  errorMessage: PropTypes.string,
  customConfirmButtonResource: PropTypes.string,
  customCancelButtonResource: PropTypes.string,
  formatMessageBodyAsHTML: PropTypes.bool,
  customCssClass: PropTypes.string,
  hideCloseButton: PropTypes.bool,
  isADeleteAction: PropTypes.bool
};

AlertGenericModal.defaultProps = {
  isLoading: false,
  errorMessage: null,
  customConfirmButtonResource: null,
  customCancelButtonResource: null,
  formatMessageBodyAsHTML: false,
  customCssClass: null,
  hideCloseButton: false,
  isADeleteAction: false
};

export default AlertGenericModal;
